'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _authors = require('../actions/authors');

var defaultState = [];

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];


    switch (action.type) {
        case _authors.actionTypes.FETCH_AUTHORS_SUCCEEDED:
            return action.authors;
        default:
            return state;
    }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvcmVkdWNlcnMvYXV0aG9ycy5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0U3RhdGUiLCJzdGF0ZSIsImFjdGlvbiIsInR5cGUiLCJhY3Rpb25UeXBlcyIsIkZFVENIX0FVVEhPUlNfU1VDQ0VFREVEIiwiYXV0aG9ycyJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7O0FBRUEsSUFBTUEsZUFBZSxFQUFyQjs7a0JBRWUsWUFBa0M7QUFBQSxRQUFqQ0MsS0FBaUMsdUVBQXpCRCxZQUF5QjtBQUFBLFFBQVhFLE1BQVc7OztBQUU3QyxZQUFRQSxPQUFPQyxJQUFmO0FBQ0ksYUFBS0MscUJBQVlDLHVCQUFqQjtBQUNJLG1CQUFPSCxPQUFPSSxPQUFkO0FBQ0o7QUFDSSxtQkFBT0wsS0FBUDtBQUpSO0FBTUgsQyIsImZpbGUiOiJhdXRob3JzLmpzIiwic291cmNlUm9vdCI6Ii9zcmMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBhY3Rpb25UeXBlcyB9IGZyb20gJy4uL2FjdGlvbnMvYXV0aG9ycyc7XG5cbmNvbnN0IGRlZmF1bHRTdGF0ZSA9IFtdO1xuXG5leHBvcnQgZGVmYXVsdCAoc3RhdGUgPSBkZWZhdWx0U3RhdGUsIGFjdGlvbikgPT4ge1xuXG4gICAgc3dpdGNoIChhY3Rpb24udHlwZSkge1xuICAgICAgICBjYXNlIGFjdGlvblR5cGVzLkZFVENIX0FVVEhPUlNfU1VDQ0VFREVEOlxuICAgICAgICAgICAgcmV0dXJuIGFjdGlvbi5hdXRob3JzO1xuICAgICAgICBkZWZhdWx0OlxuICAgICAgICAgICAgcmV0dXJuIHN0YXRlO1xuICAgIH1cbn07XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./src/client/reducers/authors.js
// module id = 2248
// module chunks = 0